(() => {
  'use strict';

  const REVIEW_CARD_SELECTOR = '.R-ContentCard.u-cursorPointer';
  const PATCHED_ATTRIBUTE = 'data-reviews-io-a11y-patched';

  function patchReviewCard(card) {
    if (!(card instanceof HTMLElement)) {
      return;
    }

    card.removeAttribute('tabindex');

    if (card.getAttribute('role') === 'button') {
      card.removeAttribute('role');
    }

    if (card.getAttribute('aria-label')?.startsWith('Review details')) {
      card.removeAttribute('aria-label');
    }

    if (card.hasAttribute(PATCHED_ATTRIBUTE)) {
      card.removeAttribute(PATCHED_ATTRIBUTE);
    }
  }

  function patchReviewCards(root = document) {
    if (root instanceof Element && root.matches(REVIEW_CARD_SELECTOR)) {
      patchReviewCard(root);
    }

    if (typeof root.querySelectorAll !== 'function') {
      return;
    }

    root.querySelectorAll(REVIEW_CARD_SELECTOR).forEach(patchReviewCard);
  }

  function observeReviewsWidget() {
    patchReviewCards();

    if (!('MutationObserver' in window) || !document.body) {
      return;
    }

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.target instanceof Element) {
          patchReviewCards(record.target);
        }

        record.addedNodes.forEach((node) => {
          if (node instanceof Element) {
            patchReviewCards(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'role', 'tabindex'],
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeReviewsWidget, { once: true });
  } else {
    observeReviewsWidget();
  }
})();
